import React from 'react';
import {FaCircleExclamation, FaCircleInfo} from "react-icons/fa6";

const AlertCard = ({children, title, type}) => {
    const alerts = {
        danger: {
            icon: <FaCircleExclamation className="h-5 w-5 text-red-600"/>,
            wrapper: "border-red-200 bg-red-50 text-red-900",
            accent: "bg-red-500",
            title: "text-red-800",
            body: "text-red-700",
        },
        warning: {
            icon: <FaCircleExclamation className="h-5 w-5 text-amber-600"/>,
            wrapper: "border-amber-200 bg-amber-50 text-amber-900",
            accent: "bg-amber-500",
            title: "text-amber-800",
            body: "text-amber-700",
        },
        info: {
            icon: <FaCircleInfo className="h-5 w-5 text-sky-600"/>,
            wrapper: "border-sky-200 bg-sky-50 text-sky-900",
            accent: "bg-sky-500",
            title: "text-sky-800",
            body: "text-slate-700",
        },
    };

    const alert = alerts[type] ?? alerts.info;

    return (
        <div
            role="alert"
            className={`relative w-full overflow-hidden rounded-md border shadow-sm ${alert.wrapper}`}
        >
            <span className={`absolute inset-y-0 left-0 w-1 ${alert.accent}`} aria-hidden="true"/>
            <div className="flex gap-3 px-4 py-3 pl-5">
                <div className="mt-0.5 flex-shrink-0">
                    {alert.icon}
                </div>
                <div className="min-w-0">
                    <p className={`mb-1 text-sm font-semibold uppercase ${alert.title}`}>
                        {title}
                    </p>
                    <div className={`space-y-1 text-sm leading-5 ${alert.body}`}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertCard;
